<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function() {
    document.querySelectorAll('.site-nav-list a[href="#"]').forEach(function(item) {
        item.classList.add('no-link');
    });

    $(document).on('click', '.epr-collaps-btn.btn.button', function(event) {
        $(".form.mag-logo-wrapper").hide();
        $('svg.bi.bi-star-fill.mag-ratings').attr('fill', 'orange')
    });
});